import { RBACAction, RBACModule } from '@numeo/types-core'
import { usePermissions } from '@/hooks/usePermissions'

/** Whether the signed-in user may create invoices (`accounting:create`), the Invoices page's own check. Without it the chat lists loads but offers no invoice action. */
export const useCanCreateInvoices = (): boolean => usePermissions().hasPermission(RBACModule.ACCOUNTING, RBACAction.CREATE)

/** Said where the invoice actions would be, for a user who can see the loads but not create invoices. */
export const CANNOT_INVOICE_NOTE = 'You can view these but not create invoices'
